import ask from '@/utils/http'

export default {
  // 获取所有接口汇总
  getInterface: (params = {}) => ask.get(`/backstage/interface`, params),
  // 获取所有即使通讯账号
  getImAccount: (params = {}) => ask.get(`/backstage/imAccount`, params),
  // 更新账号启用状态
  updateOneAccount: (params = {}) => ask.get(`/backstage/updateOneAccount`, params),
  // 批量更新账号启用状态
  updateAccount: (params = {}) => ask.get(`/backstage/updateAccount`, params),
}



// WEBPACK FOOTER //
// ./src/api/im.js